//noinspection JSUnusedGlobalSymbols

import Helper from '../../../client/helper'
import Ui from '../../../client/ui'
import type { Type } from '../../../type'

//@ts-ignore
import Sortable from 'sortablejs'

export default class
{
	static gender_menu(gender:'male'|'female'):void
	{
		$(`.menu-female, .menu-male`).css('display', 'none')
		$(`.menu-${gender}`).css('display', 'block')
	}

	static track_length():void
	{
		const length_check = (field:string, target:JQuery<HTMLElement>) =>
		{
			const value = Helper.string(target.val())
			let length = value.length

			const ascii = value.match(/[\x20-\x7e]/g)
			if(ascii !== null) length -= ascii.length / 2

			$(field).text(length)
		}

		for(const type of ['comment', 'style', 'menu', 'point'])
		{
			const target = $(`#length-${type}-target`)
			const field = `#length-${type}`

			target.on('keyup', length_check.bind(this, field, target))
			length_check(field, target)
		}
	}

	static clone_style(style_id:number, style_name:string):void
	{
		if(!confirm(`"${style_name}"をコピーしますか？`)) return

		Ui.post('/style/', {
			_action : 'clone',
			style_id: Helper.string(style_id),
		}, (success:boolean) =>
		{
			if(success) Ui.reload()
		})
	}

	static set_sortable():void
	{
		$('#sort').tablesorter({
			sortInitialOrder: 'asc',
			resort          : false,

			textExtraction: (node:string) =>
			{
				const value = $(node).attr('data-sort')
				return typeof value !== 'undefined' ? value : $(node).text()
			},
		})

		if(!Ui.is_mobile()) new Sortable($('#sort tbody')[0])
	}

	protected static _checked = false

	static invert_select(button:HTMLAnchorElement):void
	{
		this._checked = !this._checked
		$('#sort input[type="checkbox"]').prop('checked', this._checked)

		const icon = $(button).find('.fa')

		if(icon.hasClass('fa-square'))
		{
			icon.removeClass('fa-square')
			icon.addClass('fa-check-square')
		}
		else
		{
			icon.removeClass('fa-check-square')
			icon.addClass('fa-square')
		}
	}

	static alter_setting(form:HTMLFormElement):void
	{
		const checkbox = $('#sort input[type="checkbox"]:checked')
		const checked:number[] = []

		checkbox.each((index, element) =>
		{
			checked.push(Number($(element).attr('name')))
		})

		const parameter:Type.hash = {
			_action: 'setting',
			style  : JSON.stringify(checked),
		}

		if(form._clone_list.checked)
		{
			parameter._action = 'clone_list'
			parameter.clone_type = form.clone_type.value
		}
		else if(form._remove_remote.checked)
		{
			parameter._action = 'remove_remote'
		}
		else
		{
			if(form.on_time_check.checked) parameter.on_time = form.on_time.checked ? '1' : '0'
			if(form.pause_update_check.checked) parameter.pause_update = form.pause_update.checked ? '1' : '0'
			if(form.start_check.checked) parameter.start = form.start.value
			if(form.end_check.checked) parameter.end = form.end.value
			if(form.update_anchor_time_check.checked) parameter.update_anchor_time = form.update_anchor_time.value
			if(form.update_period_minute_check.checked) parameter.update_period_minute = form.update_period_minute.value
			if(form.stylist_check.checked) parameter.stylist = form.stylist.value
			if(form.hidden_check.checked) parameter.hidden = form.hidden_input.checked ? '1' : '0'

			if(Object.keys(parameter).length === 2)
			{
				Ui.notify('warning', '設定を選択してください')
				return
			}
		}

		if(checked.length === 0)
		{
			Ui.notify('warning', 'スタイルを選択してください')
			return
		}

		if(form._remove_remote.checked)
		{
			if(!confirm('選択したスタイルをシステム上と、コピーしたスタイルをサロンボード上から削除しますか？')) return
		}
		else
		{
			if(!Ui.confirm('submit')) return
		}

		Ui.post('/style/', parameter)
	}

	static change_hidden(hidden:boolean)
	{
		const url = location.href.replace(/[?&]hidden=\d?/, '')
		const connector = location.href.match(/\?/) ? '&' : '?'

		if(hidden) location.href = `${url}${connector}hidden=1`
		else location.href = url
	}

	static delete_image(position:string):void
	{
		$(`#image-delete-${position}`).prop('disabled', false)
		$(`#image-delete-button-${position}`).addClass('hidden')
		$(`#image-position-${position}`).selectpicker('val', '')

		const image = $(`#image-${position}`)
		image.attr('src', null)

		//@ts-ignore
		$(`#image-input-${position}`).filestyle('clear')

		if(String(position).match(/^MOVIE_/))
		{
			$(`#image-${position}`).addClass('invisible')
		}
		else
		{
			image.css('width', '1px')
		}
	}

	static monitor_image_change():void
	{
		const input_image = $('input[type="file"].ui-input-file-image')

		input_image.each((index, input) =>
		{
			input.addEventListener('change', function()
			{
				const position = $(input).attr('name')
				$(`#image-${position}`).css('width', 'auto')

				$(`#image-delete-${position}`).prop('disabled', true)
				$(`#image-delete-button-${position}`).removeClass('hidden')

				if(String(position).match(/^MOVIE_/)) $(`#image-${position}`).removeClass('invisible')
			})
		})
	}

	static save_order(input:boolean)
	{
		const type = input ? '数字順' : '表示順'
		if(!confirm(`${type}順序を保存しますか？`)) return false

		const order:number[] = []
		const sort:Type.hash<number> = {}

		if(input)
		{
			$('#sort tbody tr td input[name="order"]').each((index, element) =>
			{
				sort[$(element).data('id')] = Number((element as HTMLInputElement).value)
			})

			const ordered = Object.keys(sort).sort(function(a, b)
			{
				return sort[a] - sort[b]
			})

			for(const id of ordered) order.push(Number(id))
		}
		else
		{
			$('#sort tbody tr').each((index, element) =>
			{
				order.push($(element).data('href'))
			})
		}

		Ui.post('/style/', {
			_action: 'order',
			order  : JSON.stringify(order),
		})
	}

	static change_type(type:string)
	{
		$('#type_image, #type_movie').hide()
		$(`#type_${type}`).show()
	}
}
